import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMedicationatDashboard } from 'apiServices/reducer/apiService';
import { CTGrid, StethoscopeLoading } from 'components';

const Medications = (props) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.apiService.login);
    const isProvider = userData.user_type_name === 'Provider';
    const userId = props.selectedFamilyMember?.user_id || props.userId || (isProvider ? localStorage.getItem('patientUserId') : userData.user_id);
    const token = useSelector((state) => state.apiService?.token);

    const [medications, setMedications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userId || !token) {
            setLoading(false);
            setMedications([]);
            return;
        }
        setLoading(true);
        dispatch(getMedicationatDashboard({ user_id: userId, token }))
            .then((response) => {
                const rawData = response.payload?.Table || [];
                const formattedData = rawData.map((medication) => ({
                    medication: medication.medication_name || medication.medication || '',
                    dose: medication.medication_dose || medication.dose || '',
                    frequency: medication.medication_recurrence || medication.frequency || '',
                    startedFrom: medication.medication_started_from || medication.startedFrom || '',
                    comments: medication.medication_comments || medication.comments || '',
                    status: medication.medication_status || medication.status || 'Active'
                }));
                setMedications(formattedData);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [userId, token, dispatch, props.selectedFamilyMember]);

    const medColumns = [
        { headerName: "Medication", field: "medication", tooltipField: 'medication', headerTooltip: 'Medication' },
        { headerName: "Dose", field: "dose", tooltipField: 'dose', headerTooltip: 'Dose' },
        { headerName: "Frequency", field: "frequency", tooltipField: 'frequency', headerTooltip: 'Frequency' },
        { headerName: "Started From", field: "startedFrom", tooltipField: 'startedFrom', headerTooltip: 'Started From' },
        { headerName: "Comments", field: "comments", tooltipField: 'comments', headerTooltip: 'Comments' },
        { headerName: "Status", field: "status", tooltipField: 'status', headerTooltip: 'Status' }
    ];

    if (loading) {
        return (
            <StethoscopeLoading message="Loading..." />
        );
    }

    // If hideHeader is true, show only the grid (no card header/footer)
    if (props.hideHeader) {
        return (
            <div style={{ padding: '16px 12px' }}>
                <CTGrid
                    rowData={medications}
                    columnDefs={medColumns}
                    height={250}
                    enableBrowserTooltips={true}
                    tooltipShowDelay={0}
                />
            </div>
        );
    }

    // Default: show full card with header, grid, and footer
    return (
        <div className="card shadow-lg p-0">
            <div className="card-header p-3 title">Active Medications</div>
            <div className="card-body p-0">
                <CTGrid
                    rowData={medications}
                    columnDefs={medColumns}
                    height={props.gridHeight}
                    enableBrowserTooltips={true}
                    tooltipShowDelay={0}
                />
            </div>
            <div className="card-footer text-start d-flex p-x4 d-flex">
                <span variant="text" className="modalfooterclickeventtext " onClick={props.handleAddClick}>Add</span>
                <span className="mx-2 text-muted"> |</span>
                <span variant="text" className="modalfooterclickeventtext cursor-pointer" onClick={props.handleAddClick}>Edit</span>
            </div>
        </div>
    );
};

export default Medications;